import type { SurfaceKey } from "types/interfaces/access";
import type { RoleProfile } from "./legacyRoles";

/** Action keys the server exports in `access.actions`. */
export const ACTIONS = {
  AI_AGENT_OPEN: "ai_agent.open",
  ACCESS_GROUPS_MANAGE: "access_groups.manage",
  ACCESS_GROUPS_ASSIGN: "access_groups.assign",
  CLIENT_VIEW_OPEN: "client_view.open",
  DATA_STORAGE_CLIENT_FOLDERS: "data_storage.client_folders",
  DATA_STORAGE_DELETE: "data_storage.delete",
  DATA_STORAGE_EMPLOYEE_FOLDER: "data_storage.employee_folder",
  DATA_STORAGE_ORGANIZE: "data_storage.organize",
  DATA_STORAGE_PREPARE_DOWNLOADS: "data_storage.prepare_downloads",
  INTEGRATIONS_EDIT: "integrations.edit",
  INTEGRATIONS_FILES: "integrations.files",
  INTEGRATIONS_PLATFORM_EDIT: "integrations_platform.edit",
  INTEGRATIONS_PLATFORM_PORTAL: "integrations_platform.portal",
  INTEGRATIONS_PLATFORM_REVEAL: "integrations_platform.reveal",
  INTEGRATIONS_PLATFORM_RUN: "integrations_platform.run",
  INTEGRATIONS_PLATFORM_STRUCTURE: "integrations_platform.structure",
  INTEGRATIONS_REVEAL: "integrations.reveal",
  INTEGRATIONS_SETTINGS: "integrations.settings",
  PARTNER_MANAGEMENT_EDIT: "partner_management.edit",
  SECURE_EXCHANGE_DELETED: "secure_exchange.deleted",
  SFTP_MANAGEMENT_EDIT: "sftp_management.edit",
  USER_MANAGEMENT_AGENT_EDIT: "user_management.agent_edit",
  USER_MANAGEMENT_EDIT: "user_management.edit",
} as const;

export const openAction = (surface: SurfaceKey): string => `${surface}.open`;

/** The server's decision for this profile; anything it did not grant is refused. */
export function can(profile: RoleProfile, key: string): boolean {
  return profile?.access?.actions?.[key] === true;
}

export const canSee = (profile: RoleProfile, surface: SurfaceKey): boolean =>
  can(profile, openAction(surface));

/** Viewing as someone shows what they see, never more than the viewer holds. */
export function canInClientView(
  viewed: RoleProfile,
  real: RoleProfile,
  key: string,
): boolean {
  return can(viewed, key) && can(real, key);
}
